import { NoteType } from "actions/noteActions";
import styles from './styles.module.scss';
import { dateFormatter } from 'lib/commonFunctions';
import { useLocation, useParams } from "react-router-dom";
import { usePopulateReportUserNotesAnswers } from "hooks/usePopulateReportUserNotesAnswers";


export const SurvivorNotes = () => {
  const { reportId } = useParams<{ reportId: string }>();
  const location = useLocation() as { state?: { getNotes?: boolean } };
  const getNotes = location.state?.getNotes ?? true;
  const { reportUserNotesAnswers } = usePopulateReportUserNotesAnswers({
    reportId: reportId ?? null,
    getNotes,
    enabled: Boolean(reportId),
  });

  return (
    <div className={styles.survivorNotes}>
      {reportUserNotesAnswers.notes?.map((note: NoteType) => {
        const reportUserId = reportUserNotesAnswers.report?.userId;
        return (note.userId === reportUserId) && (
          <div className={styles.reportUpdate} key={note.id}>
            <h2 className={styles.dateCreated}>{note.createdAt && dateFormatter(note.createdAt)}</h2>
            <p>{note.note}</p>
          </div>
        );
      })}
    </div>
  );
}
